import React from "react";
import {
  // Navegação e Interface
  Menu,
  X,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ChevronsLeft,
  ChevronsRight,
  ArrowLeft,
  ArrowRight,
  Home,
  Settings,

  // Usuários e Pessoas
  User,
  Users,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  Crown,
  Shield,

  // Ações
  Plus,
  Minus,
  Edit,
  Edit2,
  Trash2,
  Save,
  Download,
  Upload,
  Search,
  Filter,
  RefreshCw,
  RotateCcw,
  Check,
  CheckCircle,

  // Estados e Alertas
  AlertCircle,
  AlertTriangle,
  Info,
  XCircle,
  HelpCircle,

  // Comunicação
  Mail,
  Send,
  MessageCircle,
  Phone,
  Bell,
  BellRing,
  BellOff,

  // Documentos e Arquivos
  File,
  FileText,
  Download as FileDownload,
  Upload as FileUpload,
  Folder,
  FolderOpen,
  Archive,
  List,

  // Igreja e Religião
  Heart,
  Star,
  Award,
  Gift,
  Calendar,
  Clock,
  History,
  MapPin,

  // Sistema
  Eye,
  EyeOff,
  Lock,
  Unlock,
  Key,
  LogOut,
  LogIn,
  Database,
  Server,
  Power,
  Droplet,

  // Tema e Aparência
  Sun,
  Moon,
  Palette,
  Monitor,

  // Mídia e Conteúdo
  Image,
  Camera,
  Video,
  Music,
  Volume2,
  VolumeX,

  // Conectividade e Energia
  Wifi,
  WifiOff,
  Zap,

  // Loading e Animações
  Loader2,

  // Dados e Análise
  BarChart3,
  PieChart,
  TrendingUp,
  TrendingDown,
  Activity,

  // Financeiro
  DollarSign,
  CreditCard,
  Receipt,
  Wallet,
  Hash,
  Inbox,

  // Extras
  Bookmark,
  BookmarkPlus,
  Flag,
  Tag,
  Link,
  Copy,
  Share,
  Share2,
  Printer,
  ExternalLink,
  Maximize,
  Minimize,

  // Específicos da Igreja
  Church,
  Globe,
  Code,
  Mic,
  Baby,
  Trash,
  Compass,
  BrushCleaning,
  Navigation,
  Car,
  BookOpen,
  Target,
  Book,
  ScrollText,
  Triangle,
  Wind,
  ShieldCheck,
  Sunrise,
} from "lucide-react";

// Mapeamento de ícones por nome
const iconMap = {
  // Navegação e Interface
  menu: Menu,
  close: X,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  ArrowLeft: ArrowLeft,
  ArrowRight: ArrowRight,
  home: Home,
  settings: Settings,

  // Ícones em formato Pascal Case para compatibilidade
  ChevronDown: ChevronDown,
  ChevronUp: ChevronUp,
  ChevronsLeft: ChevronsLeft,
  ChevronsRight: ChevronsRight,
  "chevrons-left": ChevronsLeft,
  "chevrons-right": ChevronsRight,
  Mail: Mail,
  Info: Info,

  // Usuários e Pessoas
  user: User,
  users: Users,
  Users: Users,
  "user-plus": UserPlus,
  "user-minus": UserMinus,
  "user-check": UserCheck,
  "user-x": UserX,
  crown: Crown,
  Crown: Crown,
  shield: Shield,

  // Ícones em formato Pascal Case para compatibilidade
  User: User,
  Shield: Shield,

  // Ações
  plus: Plus,
  minus: Minus,
  edit: Edit,
  "edit-2": Edit2,
  trash: Trash2,
  "trash-2": Trash2,
  save: Save,
  download: Download,
  upload: Upload,
  search: Search,
  Search: Search,
  filter: Filter,
  Filter: Filter,
  refresh: RefreshCw,
  RefreshCw: RefreshCw,
  "refresh-ccw": RefreshCw,
  undo: RotateCcw,
  check: Check,
  "check-circle": CheckCircle,
  x: X,

  // Ícones em formato Pascal Case para compatibilidade
  Edit2: Edit2,
  Check: Check,
  X: X,
  Edit: Edit,
  Settings: Settings,
  Palette: Palette,

  // Estados e Alertas
  alert: AlertCircle,
  "alert-circle": AlertCircle,
  AlertCircle: AlertCircle,
  warning: AlertTriangle,
  AlertTriangle: AlertTriangle,
  info: Info,
  error: XCircle,
  XCircle: XCircle,
  "x-circle": XCircle,
  help: HelpCircle,

  // Comunicação
  mail: Mail,
  send: Send,
  message: MessageCircle,
  phone: Phone,
  bell: Bell,
  "bell-ring": BellRing,
  "bell-off": BellOff,
  "message-circle": MessageCircle,

  // Documentos e Arquivos
  file: File,
  "file-text": FileText,
  "file-download": FileDownload,
  "file-upload": FileUpload,
  folder: Folder,
  "folder-open": FolderOpen,
  archive: Archive,

  // Igreja e Religião
  heart: Heart,
  star: Star,
  award: Award,
  gift: Gift,
  calendar: Calendar,
  Calendar: Calendar,
  clock: Clock,
  Clock: Clock,
  history: History,
  History: History,
  "map-pin": MapPin,
  church: Heart, // Substituindo Church por Heart
  cross: Plus, // Substituindo Cross por Plus

  // Sistema
  eye: Eye,
  Eye: Eye,
  "eye-off": EyeOff,
  EyeOff: EyeOff,
  lock: Lock,
  unlock: Unlock,
  key: Key,
  Key: Key,
  logout: LogOut,
  login: LogIn,
  "log-in": LogIn,
  database: Database,
  Database: Database,
  server: Server,
  power: Power,
  Power: Power,
  droplet: Droplet,
  Droplet: Droplet,

  // Ícones em formato Pascal Case para compatibilidade
  Lock: Lock,
  LogOut: LogOut,
  Server: Server,

  // Tema e Aparência
  sun: Sun,
  moon: Moon,
  palette: Palette,
  monitor: Monitor,

  // Mídia e Conteúdo
  image: Image,
  camera: Camera,
  video: Video,
  music: Music,
  "volume-on": Volume2,
  "volume-off": VolumeX,

  // Conectividade e Energia
  wifi: Wifi,
  "wifi-off": WifiOff,
  "wifi-x": WifiOff,
  zap: Zap,
  bolt: Zap,

  // Loading e Animações
  loader: Loader2,
  "loader-2": Loader2,

  // Ícones em formato Pascal Case para compatibilidade
  Camera: Camera,

  // Dados e Análise
  "bar-chart": BarChart3,
  "pie-chart": PieChart,
  "trending-up": TrendingUp,
  "trending-down": TrendingDown,
  activity: Activity,

  // Financeiro
  "dollar-sign": DollarSign,
  "credit-card": CreditCard,
  receipt: Receipt,
  wallet: Wallet,
  hash: Hash,
  inbox: Inbox,
  list: List,

  // Extras
  bookmark: Bookmark,
  "bookmark-star": BookmarkPlus,
  "bookmark-plus": BookmarkPlus,
  flag: Flag,
  tag: Tag,
  link: Link,
  copy: Copy,
  share: Share,
  share2: Share2,
  print: Printer,
  "external-link": ExternalLink,
  "box-arrow-up-right": ExternalLink,
  "arrow-clockwise": RefreshCw,
  maximize: Maximize,
  minimize: Minimize,
  "volume-2": Volume2,
  volume: Volume2,

  // Navegadores e Sistemas
  chrome: Globe,
  Chrome: Globe,

  // Mapeamentos adicionais para compatibilidade
  Monitor: Monitor,
  Globe: Globe,
  Code: Code,

  // Ícones de escalas
  mic: Mic,
  baby: Baby,
  compass: Compass,
  "brush-cleaning": BrushCleaning,

  // Ícones de localização e transporte
  navigation: Navigation,
  Navigation: Navigation,
  car: Car,
  Car: Car,

  // Ícones de livros e leitura
  "book-open": BookOpen,
  BookOpen: BookOpen,
  book: Book,
  Book: Book,

  // Ícones de objetivo
  target: Target,
  Target: Target,

  // Ícones da Confissão de Fé
  scroll: ScrollText,
  triangle: Triangle,
  wind: Wind,
  "shield-check": ShieldCheck,
  sunrise: Sunrise,
};

// Componente Icon
const Icon = ({
  name,
  size = 16,
  color,
  className = "",
  style = {},
  onClick,
  ...otherProps
}) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  const iconStyle = {
    color: color || "currentColor",
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  // Props válidas para componentes Lucide React
  const lucideProps = {
    size: Number(size),
    className,
    style: iconStyle,
    onClick,
    ...(color && { stroke: color }),
  };

  return <IconComponent {...lucideProps} />;
};

// Hook para obter cor do tema atual
export const useIconColor = (variant = "default") => {
  const colors = {
    default: "var(--color-text)",
    primary: "var(--color-primary)",
    secondary: "var(--color-secondary)",
    success: "var(--color-success)",
    danger: "var(--color-danger)",
    warning: "var(--color-warning)",
    info: "var(--color-info)",
    muted: "var(--color-text-muted)",
    light: "var(--color-surface)",
    dark: "var(--color-background)",
  };

  return colors[variant] || colors.default;
};

// Componente Icon com variantes de cor
export const ThemedIcon = ({ variant = "default", ...props }) => {
  const color = useIconColor(variant);
  return <Icon color={color} {...props} />;
};

// Lista de todos os ícones disponíveis (para debug/desenvolvimento)
export const availableIcons = Object.keys(iconMap);

export default Icon;
